import { graphqlDynamic } from "react-apollo-dynamic-query"
import gql from "graphql-tag"
import RoundingMonitorCard from "."
import { connect } from "react-redux"
import { getMatchFromRouter } from "../../helpers/sharedHelperFunctions"
import moment from "moment"

const startAt = moment()
  .subtract(12, "hours")
  .format()
const endAt = moment()
  .add(12, "hours")
  .format()

export const generateTableDataQuery = () => {
  return gql`
    query VisitsQuery(
      $facilityID: ID!
      $unitID: ID!
      $startAt: String!
      $endAt: String!
    ) {
      facility(id: $facilityID) {
        id
        name
        unit(id: $unitID) {
          id
          name
          shifts {
            roundingVisitDurationSeconds
            roundingPeriodMinutes
            startHour
            endHour
          }
          locations(patientArea: true) {
            id
            name
            occupancy(startAt: $startAt, endAt: $endAt) {
              edges {
                node {
                  startAt
                  endAt
                }
              }
            }
            visits(startAt: $startAt, endAt: $endAt) {
              edges {
                node {
                  id
                  duration
                  user {
                    id
                    name
                  }
                  entry {
                    capturedAt
                  }
                  exit {
                    capturedAt
                  }
                }
              }
            }
          }
        }
      }
    }
  `
}

const RoundingMonitorCardWithApollo = graphqlDynamic(generateTableDataQuery, {
  options: ({ facilityId, unitId, startAt, endAt }) => ({
    variables: {
      facilityID: facilityId,
      unitID: unitId,
      startAt,
      endAt,
    },
    pollInterval: 60000,
  }),
  props: props => {
    const { error, loading, facility } = props.data

    if (error) {
      throw error
    }
    if (!loading) {
      if (!facility) {
        throw Error("404")
      }

      const locationsWithOccupancies = facility.unit.locations.filter(
        location => {
          // if there's a node with a endAt being null, it means the room is occupied.
          return location.occupancy.edges.find(edge => edge.node.endAt === null)
        }
      )

      const locationsWithNamesandRounded = locationsWithOccupancies.map(
        location => {
          const sortedVisits = location.visits.edges.sort((a, b) => {
            if (a.node.exit.capturedAt < b.node.exit.capturedAt) return 1
            if (a.node.exit.capturedAt > b.node.exit.capturedAt) return -1
            return 0
          })

          const currentHour = moment().hour()
          const dayShift = facility.unit.shifts[0]
          const nightShift = facility.unit.shifts[1]
          let roundingDuration
          let roundingDurationMinutes

          // we know we are in day shift
          /* istanbul ignore next */
          if (
            currentHour >= dayShift.startHour &&
            currentHour < dayShift.endHour
          ) {
            roundingDuration = dayShift.roundingVisitDurationSeconds
            roundingDurationMinutes = dayShift.roundingPeriodMinutes
          } else {
            // we know we are in night shift
            roundingDuration = nightShift.roundingVisitDurationSeconds
            roundingDurationMinutes = nightShift.roundingPeriodMinutes
          }

          const lastVisitLongerThanRoundingDuration = sortedVisits.find(
            visit => visit.node.duration >= roundingDuration
          )

          let lastRounded = null
          if (lastVisitLongerThanRoundingDuration)
            lastRounded =
              lastVisitLongerThanRoundingDuration.node.exit.capturedAt

          return {
            id: location.id,
            name: location.name,
            lastRounded: lastRounded,
            roundingDurationMinutes: roundingDurationMinutes,
          }
        }
      )

      return {
        loading,
        unitName: facility.unit.name,
        facilityName: facility.name,
        locations: locationsWithNamesandRounded,
      }
    } else {
      return { loading, error }
    }
  },
})(RoundingMonitorCard)

const mapStateToProps = ({ router }) => {
  const match = getMatchFromRouter(router)
  return {
    unitId: match.params.entityId,
    facilityId: match.params.parentEntityId,
    startAt: startAt,
    endAt: endAt,
  }
}

const RoundingMonitorCardWithData = connect(mapStateToProps)(
  RoundingMonitorCardWithApollo
)

export default RoundingMonitorCardWithData
